import React from 'react';
import './receiptDownload.css';

/**
 * ReceiptDownload — "Open payment receipt" on a confirmation screen.
 *
 * It OPENS the PDF in a new tab rather than downloading it (2026-08-14) — the
 * same behaviour as the invoice PDFs elsewhere in the portal. The endpoints
 * serve it `inline`, so the browser renders it instead of dropping a file into
 * the downloads folder; saving is then the reader's own choice.
 *
 * A PLAIN LINK. Nothing else (2026-08-14, after every clever version failed
 * on his screen while every request I made from curl and from a browser console
 * succeeded).
 *
 * What this replaced, and why each part had to go:
 *   · resolving the Zoho payment id in the browser, then fetching the PDF with
 *     it — two round trips and a retry loop, so four ways to end up showing
 *     "still being prepared" while the receipt existed;
 *   · downloading via fetch + Blob + a scripted anchor click — silently dropped
 *     by the browser when the click is seconds old, which is exactly the
 *     saved-card case (its payment id lands after the confirmation appears);
 *   · a busy state that could outlive the request that set it.
 *
 * The SERVER now resolves the id from our own rows and streams the PDF in one
 * call (GET /client-requests/wallet/receipt-pdf), waiting briefly if Zoho has
 * not finished creating the payment. The browser just follows a link — the same
 * thing it does everywhere else in the portal that has always worked.
 *
 *   href      the endpoint, with whatever handles the surface has
 *   label     button text
 */
export default function ReceiptDownload({ href, label = 'Open payment receipt' }) {
    if (!href) return null;
    return (
        <div className="rcpt">
            <a className="rcpt__btn" href={href} target="_blank" rel="noopener noreferrer">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <path d="M12 18v-6" />
                    <polyline points="9 15 12 18 15 15" />
                </svg>
                {label}
            </a>
        </div>
    );
}
